import React, { Fragment } from 'react'
import ToggleSwitch from './toggleSwitch/ToggleSwitch'
import { Volume } from './volume/Volume'
import SFXS from '../../../assets/audios/audios'
interface AudioProps {
  audio?: any
  colors: any
  handleAudio?: any
}

export default function Audio({ audio, colors, handleAudio }: AudioProps) {
  const { music, sound, volume } = audio
  const { switchSFX } = SFXS
  switchSFX.volume = volume

  return (
    <Fragment>
      <ToggleSwitch
        colors={colors}
        name='Music'
        isOn={music}
        save={() => {
          sound && switchSFX.play()
          handleAudio({ ...audio, music: !music })
        }}
      />
      <ToggleSwitch
        colors={colors}
        name='Sound'
        isOn={sound}
        save={() => {
          !sound && switchSFX.play()
          handleAudio({ ...audio, sound: !sound })
        }}
      />
      <Volume
        saveUserSetting={(v) => handleAudio({ ...audio, volume: v })}
        value={volume}
      />
    </Fragment>
  )
}
